import React, { Fragment, useState, useRef } from 'react'
import useOutsideClick from 'hooks/useOutsideClick'
import { useTranslation } from 'react-i18next'
import { withRouter } from 'react-router'
import Button from 'components/Button'
import get from 'lodash/get'

import { StyledRoot, StyledActions, StyledActionLabel, StyledTriggerWrapper } from './styled'

const ItemActions = ({ trigger, actions, history, match, location, item, handlerProps, direction = 'bottom' }) => {
	const [showActions, setShowActions] = useState(false)
	const [showSubActions, setShowSubActions] = useState({})
	const [actionIndex, setIndex] = useState(null)

	const [t] = useTranslation()

	const longPressTimeout = useRef()

	const actionProps = {
		data: item,
		history,
		match,
		location,
		...handlerProps
	}

	const toggleMenu = e => {
		setShowActions(prevState => !prevState)
	}

	const unmountModal = () => {
		setIndex(null)
	}

	const handleAction = ({ action, modalComponent, subActions, i }) => {
		if(typeof action === 'function') {
			action(actionProps)
		}
		if(modalComponent) {
			setIndex(i)
		}
		if(subActions) {
			setShowSubActions(prev => ({ ...prev, [i]: !prev[i] }))
		} else {
			setShowActions(false)
		}
	}

	const handleMouseDown = (action) => e => {
		longPressTimeout.current = setTimeout(() => {
			longPressTimeout.current = true
			if (typeof action.longPress === 'function') {
				handleAction({ ...action, action: action.longPress })
			}
		}, 1000)
	}

	const handleMouseUp = (action) => e => {
		if(longPressTimeout.current === true) {
			return
		}
		clearTimeout(longPressTimeout.current)
		if (e.detail === 1) {
			handleAction(action)
		}
	}

	const [containerRef] = useOutsideClick(() => setShowActions(false))
	const ModalComponent = get(actions, `${actionIndex}.modalComponent`)

	const renderMenu = (items, nested) => items.map((action, i) => {
		const { label, Icon, iconStyles, checkAvailability, additionalStyles, subActions } = action
		const isAvailable = typeof checkAvailability === 'function' ? checkAvailability(item, handlerProps) : true
		const actionLabel = typeof label === 'function' ? label(item, handlerProps) : label

		return(
			<div key={i}>
				<StyledActionLabel
					{ ...isAvailable && { onMouseUp: handleMouseUp({ ...action, i }), onMouseDown: handleMouseDown({ ...action, i }) }}
					isAvailable={isAvailable}
					{...iconStyles && { iconStyles }}
					nested={nested}
					additionalStyles={additionalStyles}
				>
					{Icon &&
						<Icon />
					}
					{actionLabel}
				</StyledActionLabel>
				{subActions && showSubActions[i] && renderMenu(subActions, true)}
			</div>
		)
	})

	return(
		<Fragment>
			<StyledRoot ref={containerRef}>
				{trigger ? (
					<StyledTriggerWrapper onClick={toggleMenu}>{trigger}</StyledTriggerWrapper>
				) : (
					<Button status='dropdown' text={t('common.strings.actions')} onClick={toggleMenu}/>
				)}
				{showActions &&
					<StyledActions direction={direction}>
						{renderMenu(actions)}
					</StyledActions>
				}
			</StyledRoot>
			{actionIndex !== null &&
				<ModalComponent unmount={unmountModal} {...actionProps}/>
			}
		</Fragment>
	)
}

export default withRouter(ItemActions)
